export type ViewMode = 'result' | 'parameters' | 'debug';
export type PanelSize = 'expanded' | 'fullscreen';

export const BRAND_COLORS = {
  primary: '#FF732E',
  primaryHover: '#FF8B4E',
  primaryLight: 'rgba(255, 115, 46, 0.1)',
  primaryLightHover: 'rgba(255, 115, 46, 0.2)',
} as const;
